import { Component } from '@angular/core';

@Component({
    selector: 'app-credit',
    templateUrl: './credit.component.html',
    styleUrls: ['./credit.component.scss'],
    standalone: false
})
export class CreditComponent {

}
